/* RIWI Rabattcode-Seite (.com /pages/rabattcode) — Paket B1 riwi-rabattcode-seite, 14.10.2026.
   Nur zwei Dinge:
   1. Code kopieren (navigator.clipboard, Fallback execCommand/Markieren) + Status fuer Screenreader.
   2. Kaufformulare [data-rk-form]: Set + Gratis-Zugabe ueber den BESTEHENDEN Kaufweg
      window.RiwiLp2Cart.addAndApply (assets/riwi-lp2.js): EIN add.js, Codes aus cart.js gemerged,
      Zugabe faellt wieder raus, wenn der Code nicht greift; Routen ueber Shopify.routes.root.
      Fehlt RiwiLp2Cart oder fetch -> natives Formular (nur das Set, wie LP2 ohne JS).
   Keine kundensichtbaren Texte hier: sie kommen aus data-Attributen (Locale-Keys im Liquid). */
(function () {
  'use strict';
  if (window.__riwiAktInit) return;
  window.__riwiAktInit = true;

  function root() { return document.querySelector('.riwi-akt'); }
  function txt(name) { var r = root(); return (r && r.getAttribute(name)) || ''; }

  var live = null;
  function announce(msg) {
    if (!live) {
      live = document.createElement('p');
      live.className = 'rk-vh';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      (root() || document.body).appendChild(live);
    }
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 30);
  }

  function legacyCopy(code) {
    try {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand && document.execCommand('copy');
      document.body.removeChild(ta);
      return !!ok;
    } catch (e) { return false; }
  }

  function selectCode(btn) {
    var box = btn.closest('.rk-code');
    var val = box && box.querySelector('.rk-code-val');
    if (!val || !window.getSelection) return;
    var range = document.createRange();
    range.selectNodeContents(val);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }

  function copied(btn, code, ok) {
    var label = btn.querySelector('[data-rk-copy-txt]');
    if (!ok) {
      selectCode(btn);
      announce(txt('data-rk-copy-fail'));
      return;
    }
    if (label) {
      if (!btn.__rkLabel) btn.__rkLabel = label.textContent;
      label.textContent = txt('data-rk-copied') || btn.__rkLabel;
    }
    btn.classList.add('is-copied');
    announce((txt('data-rk-copied') ? txt('data-rk-copied') + ': ' : '') + code);
    window.clearTimeout(btn.__rkT);
    btn.__rkT = window.setTimeout(function () {
      btn.classList.remove('is-copied');
      if (label && btn.__rkLabel) label.textContent = btn.__rkLabel;
    }, 2200);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-rk-copy]') : null;
    if (!btn) return;
    var code = btn.getAttribute('data-rk-copy') || '';
    if (!code) return;
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(
        function () { copied(btn, code, true); },
        function () { copied(btn, code, legacyCopy(code)); }
      );
    } else {
      copied(btn, code, legacyCopy(code));
    }
  });

  /* Capture am document: laeuft VOR jedem submit-Listener am Formular selbst. */
  var busy = false;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-rk-form')) return;
    var Cart = window.RiwiLp2Cart;
    if (!Cart || typeof Cart.addAndApply !== 'function' || typeof window.fetch !== 'function') return;
    var idInput = form.querySelector('input[name="id"]');
    var setId = idInput ? parseInt(idInput.value, 10) : 0;
    if (!setId) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;

    var giftId = parseInt(form.getAttribute('data-rk-gift') || '0', 10) || 0;
    var code = (form.getAttribute('data-rk-code') || '').trim();
    var items = [{ id: setId, quantity: 1 }];
    var drop = null;
    if (giftId && code) {
      items.push({ id: giftId, quantity: 1 });
      drop = [{ id: giftId, code: code }];
    }
    var btn = form.querySelector('[data-rb-atc]');
    var err = form.querySelector('[data-rk-err]');
    if (err) { err.hidden = true; err.textContent = ''; }
    busy = true;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var release = function () {
      busy = false;
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    };
    var showErr = function (msg) {
      release();
      if (err) { err.textContent = msg || txt('data-rk-err'); err.hidden = false; }
    };
    Cart.addAndApply({
      tag: 'riwi-aktionen',
      items: items,
      codes: code ? [code] : [],
      dropIfCodeFails: drop,
      errorText: txt('data-rk-err'),
      /* Gate 1: scheitert add.js mit Set + Zugabe (z. B. Zugabe gerade ausverkauft), wird das
         Set ALLEIN nachgelegt und es geht weiter in den Warenkorb - kein toter Klick. Erst wenn
         auch das scheitert, steht die Fehlermeldung an der Karte. */
      onError: function (msg) {
        if (items.length < 2) { showErr(msg); return; }
        Cart.addAndApply({
          tag: 'riwi-aktionen set-only',
          items: [{ id: setId, quantity: 1 }],
          codes: [],
          errorText: txt('data-rk-err'),
          onError: showErr,
          onSuccess: release
        });
      },
      onSuccess: release
    });
  }, true);

  /* bfcache-Rueckkehr aus /cart: Sperre loesen (Button-Zustand setzt riwi-lp2.js zurueck). */
  window.addEventListener('pageshow', function () { busy = false; });
})();
